import { CellFieldV2 as CellField, GridColDef } from '@/components/custom/erp';

const READONLY_SEARCH_COLUMNS = [
  { field: 'ma_bp', headerName: 'Bộ phận', valueField: 'ma_bp', dataField: 'ma_bp_data' },
  { field: 'ma_vv', headerName: 'Vụ việc', valueField: 'ma_vu_viec', dataField: 'ma_vv_data' },
  { field: 'ma_hd', headerName: 'Hợp đồng', valueField: 'ma_hd', dataField: 'ma_hd_data' },
  { field: 'ma_dtt', headerName: 'Đợt thanh toán', valueField: 'ma_dtt', dataField: 'ma_dtt_data' },
  { field: 'ma_ku', headerName: 'Khế ước', valueField: 'ma_ku', dataField: 'ma_ku_data' },
  { field: 'ma_phi', headerName: 'Phí', valueField: 'ma_phi', dataField: 'ma_phi_data' },
  { field: 'ma_sp', headerName: 'Sản phẩm', valueField: 'ma_vt', dataField: 'ma_sp_data' },
  { field: 'ma_lsx', headerName: 'Lệnh sản xuất', valueField: 'ma_lsx', dataField: 'ma_lsx_data' },
  { field: 'ma_cp0', headerName: 'C/p không h/lệ', valueField: 'ma_cp', dataField: 'ma_cp0_data' }
] as const;

// Factory function to create read-only columns
const createReadOnlyColumn = (config: (typeof READONLY_SEARCH_COLUMNS)[number], width = 120): GridColDef => ({
  field: config.field,
  headerName: config.headerName,
  width,
  renderCell: (params: any) => (
    <CellField
      name={config.field}
      type='text'
      value={params.row[config.dataField]?.[config.valueField] || ''}
      disabled
    />
  )
});

export const getDetailTableColumns = (ma_ngv?: string): GridColDef[] => [
  {
    field: 'tk',
    headerName: 'Mã tài khoản',
    width: 120,
    renderCell: params => <CellField name='tk' type='text' value={params.row.tk_data?.code || ''} disabled />
  },
  {
    field: 'ten_tk',
    headerName: 'Tên tài khoản',
    width: 200,
    renderCell: params => <CellField name='ten_tk' type='text' value={params.row.tk_data?.name || ''} />
  },
  {
    field: 'ma_kh',
    headerName: 'Mã khách hàng',
    width: 120,
    renderCell: params => (
      <CellField name='ma_kh' type='text' value={params.row.ma_dt_data?.customer_code || ''} disabled />
    )
  },
  {
    field: 'ten_kh',
    headerName: 'Tên khàng',
    width: 200,
    renderCell: params => <CellField name='ten_kh' type='text' value={params.row.ma_kh_data?.customer_name || ''} />
  },
  {
    field: 'ps_no_nt',
    headerName: 'Ps nợ VND',
    width: 150,
    renderCell: params => {
      let value = params.row.ps_no_nt || 0;

      if (ma_ngv === '2') {
        value = params.row.ps_co_nt || 0;
      }

      const displayValue = ma_ngv === '1' ? -Math.abs(Number(value)) : value;
      return <CellField name='ps_no_nt' type='number' value={displayValue} disabled />;
    }
  },
  {
    field: 'ps_co_nt',
    headerName: 'Ps có VND',
    width: 150,
    renderCell: params => {
      let value = params.row.ps_co_nt || 0;

      if (ma_ngv === '2') {
        value = params.row.ps_no_nt || 0;
      }

      const displayValue = ma_ngv === '1' ? -Math.abs(Number(value)) : value;
      return <CellField name='ps_co_nt' type='number' value={displayValue} disabled />;
    }
  },
  {
    field: 'nh_dk',
    headerName: 'Nhóm',
    width: 150,
    renderCell: params => <CellField name='nh_dk' type='text' value={params.row.nh_dk || ''} disabled />
  },
  {
    field: 'dien_giai',
    headerName: 'Diễn giải',
    width: 250,
    renderCell: params => <CellField name='dien_giai' type='text' value={params.row.dien_giai || ''} disabled />
  },

  ...READONLY_SEARCH_COLUMNS.map(config => createReadOnlyColumn(config))
];
